import ShippingRepository from '../repositories/ShippingRepository';
import BillingRepository from '../repositories/BillingRepository';
import { diContainer, serviceNames } from '../diContainer/diContainer';
import Address from '../domain/entities/Address';
import NotificationsCollection from '../domain/entities/Notification/NotificationsCollection';
import TransactionLoadHandler, { ITransactionLoad } from './TransactionLoadHandler';
import { NOTIFICATION_GROUP, NOTIFICATION_TYPE } from '../constants/Notifications';
import { shippingAPONotificationsList } from '../views/Notifications/ComponentNotificationFactory';

class SaveShippingAddressUseCase extends TransactionLoadHandler {
  private address: Address;

  private shippingRepository: ShippingRepository;

  private billingRepository: BillingRepository;

  private isBillingSameAsShipping: boolean;

  private notificationsCollection: NotificationsCollection;

  constructor(address: Address, isBillingSameAsShipping: boolean, options?: ITransactionLoad) {
    super(options?.transactionLoadOptions);
    this.address = address;
    this.isBillingSameAsShipping = isBillingSameAsShipping;
    this.shippingRepository = diContainer.get(serviceNames.shippingRepository);
    this.billingRepository = diContainer.get(serviceNames.billingRepository);
    this.notificationsCollection = diContainer.get(serviceNames.notificationsCollection);
  }

  protected run = async (): Promise<void> => {
    try {
      const updatedAddress = await this.shippingRepository.updateAddress(this.address);
      const transaction = await this.transactionRepository.getTransaction();
      transaction.setShippingAddress(updatedAddress);

      this.billingRepository.updateAddressValues(updatedAddress);

      if (this.isBillingSameAsShipping) {
        transaction.setBillingAddress(updatedAddress);
      }

      this.notificationsCollection.clearNotifications(NOTIFICATION_GROUP.SHIPPING, NOTIFICATION_TYPE.DANGER);

      shippingAPONotificationsList.forEach(notification => {
        if (this.notificationsCollection.hasNotification(notification)) {
          this.notificationsCollection.clearNotificationByKey(notification);
        }
      });

    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
      await this.handleTransactionUpdate();
    }
  };
}

export default SaveShippingAddressUseCase;
